export default {
  aboutMe: 'Sobre Mim',
  aboutHer: 'Sobre Ela',
  aboutHim: 'Sobre Ele',
  moments: 'Momentos',
  interests: 'Interesses',
  languages: 'Idiomas',
  storyAlbum: 'Álbum de Histórias',
  noMoments: 'Nenhum momento ainda',
  videoCall: 'Chamada de Vídeo',
  follow: 'Seguir',
  unfollow: 'Deixar de Seguir',
  report: 'Denunciar',
  block: 'Bloquear',
  unblock: 'Desbloquear',
  unblockSuccess: 'Removido da lista negra com sucesso',
  blockTips: 'Tem certeza que deseja bloquear este usuário? Você não receberá nenhuma mensagem deste usuário após o bloqueio.',
}
